module.exports = __webpack_public_path__ + "static/img/product6.d7b8f26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/red/product6.png
// module id = 1LXn
// module chunks = 0